<template>
  <v-navigation-drawer
    app
    temporary
    v-model="drawer"
    overlay-opacity="0"
    :right="$vuetify.rtl"
    :clipped="$vuetify.breakpoint.lgAndUp"
  >
    <v-list dense>
      <v-list-item>
        <v-list-item-avatar color="primary">
          <span class="white--text headline text-uppercase">
            {{ shortEmail }}
          </span>
        </v-list-item-avatar>
        <v-list-item-content class="py-0">
          <v-list-item-title>
            {{ email || "" }}
          </v-list-item-title>
        </v-list-item-content>
        <v-btn
          icon
          @click="drawer = !drawer"
          v-if="$vuetify.breakpoint.mdAndDown"
        >
          <v-icon> mdi-chevron-{{ $vuetify.rtl ? "right" : "left" }} </v-icon>
        </v-btn>
      </v-list-item>
      <v-divider class="mt-2" />
      <template v-for="(link, i) in sidebarLinks">
        <v-subheader v-if="link.heading" :key="link.heading">
          {{ link.heading }}}
        </v-subheader>
        <v-divider :key="i" class="my-2" v-else-if="link.divider" />
        <v-list-group
          append-icon=""
          :key="link.text"
          v-model="link.model"
          v-else-if="link.children"
          :prepend-icon="link.model ? link.icon : link.iconAlt"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title> {{ link.text }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item v-for="(child, i) in link.children" :key="i" link>
            <v-list-item-action v-if="child.icon">
              <v-icon class="text-center">{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ child.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item v-else :key="link.text" :to="link.url" link>
          <v-list-item-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ link.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import avatarNameMixin from "@/mixins/avatarName";

export default {
  name: "AppDrawer",
  mixins: [avatarNameMixin],

  computed: {
    ...mapState(["sidebarLinks"]),
    ...mapGetters("auth", ["loggedIn"]),
    ...mapGetters("auth", ["currentUserData"]),
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      },
    },
    shortEmail() {
      if (this.loggedIn) {
        const email = this.currentUserData.email;
        return this.avatarName(email);
      }
      return "";
    },
    email() {
      if (this.loggedIn) {
        const email = this.currentUserData.email;
        return email;
      }
      return "";
    },
  },
};
</script>
